import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService, fromMinutesToMilliseconds, fromSecondsToMilliseconds } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class AuthTransactionConfigService {
	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getVerificationStatusEndpoint(): string {
		return this.service.get(
			(x) => x.core.authTransaction.endpoints!.verificationStatus,
			"v1/authentication-transaction/status"
		);
	}

	getVerificationEndpoint(): string {
		return this.service.get((x) => x.core.authTransaction.endpoints!.verification, "v1/authentication-transaction");
	}

	getVerificationEndpointV2(): string {
		return this.service.get(
			(x) => x.core.authTransaction.endpoints?.verificationV2,
			"v2/authentication-transaction"
		);
	}

	getNativeRedirectUrl(): string {
		return this.service.get((x) => x.core.authTransaction.nativeRedirectUrl, "");
	}

	getVerificationStatusInterval(): number {
		return this.service.get(
			(x) => x.core.authTransaction.verificationStatusInterval,
			fromSecondsToMilliseconds(1.5)
		);
	}

	getVerificationStatusTimeout(): number {
		return this.service.get((x) => x.core.authTransaction.verificationStatusTimeout, fromMinutesToMilliseconds(3));
	}

	getLoginEnabled(): boolean {
		return this.service.get((x) => x.core.authTransaction.loginEnabled, false);
	}

	getBankIdQuickLoginEnabled(): boolean {
		return this.service.get((x) => x.core.authTransaction.bankIdQuickLoginEnabled, false);
	}

	getBankIdSecureStartEnabled(): boolean {
		return this.service.get((x) => x.core.authTransaction.bankIdSecureStartEnabled, false);
	}
}
